export default __webpack_public_path__ + "static/media/xhs.89798a4c.png";